import { render, staticRenderFns } from "./QSummitCalculator.vue?vue&type=template&id=844d67ec&scoped=true&"
import script from "./QSummitCalculator.vue?vue&type=script&lang=js&"
export * from "./QSummitCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844d67ec",
  null
  
)

export default component.exports